import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import api from './api';

let registered = false;
let currentToken = null;

async function registerPush() {
  if (!Capacitor.isNativePlatform()) { console.log('[push] not native, skipping'); return; }
  if (registered) return;
  registered = true;
  try {
    let permStatus = await PushNotifications.checkPermissions();
    if (permStatus.receive === 'prompt') {
      permStatus = await PushNotifications.requestPermissions();
    }
    if (permStatus.receive !== 'granted') { console.warn('[push] permission denied'); return; }
    try {
      await PushNotifications.createChannel({
        id: 'default_channel',
        name: 'Meldingen',
        description: 'Storingen, onderhoud en afgeronde werkorders',
        importance: 5,
        visibility: 1,
        vibration: true,
        sound: 'default'
      });
    } catch (e) { console.warn('[push] createChannel failed:', e.message); }
    await PushNotifications.register();
    PushNotifications.addListener('registration', async (token) => {
      currentToken = token.value;
      try {
        await api.post('/klantportaal/device-token', { token: token.value, platform: 'android' });
        console.log('[push] token registered on backend');
      } catch (err) {
        console.error('[push] backend register failed:', err.message);
      }
    });
    PushNotifications.addListener('registrationError', (err) => {
      console.error('[push] registration error:', err);
    });
    PushNotifications.addListener('pushNotificationReceived', (n) => {
      console.log('[push] received (foreground):', n);
    });
    PushNotifications.addListener('pushNotificationActionPerformed', (action) => {
      const data = (action.notification && action.notification.data) || {};
      if (data.object_id && data.object_id !== 'null') {
        window.location.hash = '#/object/' + data.object_id;
      } else {
        window.location.hash = '#/notificaties';
      }
    });
  } catch (err) {
    console.error('[push] setup failed:', err);
  }
}

async function unregisterPush() {
  if (!currentToken) return;
  try { await api.delete('/klantportaal/device-token', { data: { token: currentToken } }); } catch {}
  try { await PushNotifications.removeAllListeners(); } catch {}
  currentToken = null;
  registered = false;
}

export { registerPush, unregisterPush };
